/**
 * Legacy Color Constants
 * 
 * ⚠️ DEPRECATED: These are kept for backward compatibility.
 * 
 * For new code, use the design system:
 * import { colors } from '../design-system';
 * 
 * To change colors, update: src/design-system/tokens.js
 */

// Re-export from design system for backward compatibility
export { colors } from '../design-system/tokens';

// Legacy exports (mapped to design system)
export const PRIMARY_COLOR = '#B8AC7F';
export const PRIMARY_COLOR_LIGHT = '#C3B890';
export const PRIMARY_COLOR_DARK = '#A5996A';
export const PRIMARY_COLOR_RGBA_20 = 'rgba(184, 172, 127, 0.2)';

